import { c as _c } from "react/compiler-runtime";
import { UserAvatar } from '@src/components/sco/Account/UserAvatar';
import { AppLayout } from '@src/components/sco/AppLayout';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { PITCH_BUILDER_INVESTOR_SEARCH_FRAGMENT } from '@src/components/sco/InvestorMatching/InvestorMatchPitchBuilder';
import { USER_SEARCH_FRAGMENT } from '@src/components/sco/Matching/userSearchFragment';
import { RequestBuilderForms } from '@src/components/sco/Requests/RequestBuilder/RequestBuilderForms';
import { RequestBuilderPreview } from '@src/components/sco/Requests/RequestBuilder/RequestBuilderPreview';
import { useWindow } from '@src/hooks/useWindow';
import { gql } from '@src/lib/gql';
import React from 'react';
type RequestBuilderProps = {
  groupRequestId: string;
};
export const REQUEST_BUILDER_GROUP_REQUEST_FRAGMENT = gql`
  fragment _ on GroupRequest {
    id
    groupRequestId
    groupRequestTypeKey
    groupRequestType {
      id
      title
      key
      colorHexCode
    }
    naturalLanguagePrompt
    displayTitle
    title
    generatedTitle
    description
    location
    locationCity
    locationCountryKey
    locationLatitude
    locationLongitude
    locationState
    needExplanation
    valueToRequester
    valueToResponder
    compensationTypeKeys
    compensationTypes {
      id
      title
      key
    }
    timeCommitmentTypeKeys
    timeCommitmentTypes {
      id
      title
      key
    }
    tagTitles
    skillTagTitles
    investorIndustryTagTitles
    requestingUser {
      id
      userId
      displayName
      firstName
      lastName
      pictureUrl
      title
      ${UserAvatar.fragments.ScoUser()}
    }
    requestingCompany {
      id
      companyId
      name
      elevatorPitch
      stageKey
      stage {
        id
        title
        key
      }
      industries {
        id
        title
        key
      }
      industryKeys
      url
    }
    displayBodyAsMarkdown
    bodyAsMarkdown
    generatedBodyAsMarkdown
    bodyPromptAdditionalItems
    bodyIsGenerated
    visibilityKey
    visibility {
      id
      title
      key
    }
    publishRequestedAt
    publishedAt
    publishStatusKey
    publishStatus {
      id
      title
      key
    }
    tags {
      id
      tagTypeKey
      title
    }
    tagTitles
    investorSearch {
      id
      ${PITCH_BUILDER_INVESTOR_SEARCH_FRAGMENT}
    }
    userSearch {
      id
      ${USER_SEARCH_FRAGMENT}
    }
    storedFiles {
      id
      items {
        id
        title
        fullUrl
        storageFileName
        storedFileId
      }
    }
  }
`;
export const RequestBuilder: React.FC<RequestBuilderProps> = props => {
  const $ = _c(20);
  const requestsLayout = useParentAppLayout();
  const window = useWindow();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      paddingX: 0,
      marginX: 0,
      gap: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `${props.groupRequestId}`;
  let t2;
  if ($[1] !== requestsLayout || $[2] !== t1) {
    t2 = <RequestBuilderForms groupRequestId={t1} requestsLayout={requestsLayout} />;
    $[1] = requestsLayout;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      bgColor: "colorPalette.panel",
      borderRadius: 0,
      border: "none"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = {
      id: "request-builder-form",
      children: t2,
      containerProps: t3
    };
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      base: true,
      lg: false
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== window?.innerWidth) {
    t6 = () => window?.innerWidth ? window?.innerWidth / 2 : 400;
    $[8] = window?.innerWidth;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `${props.groupRequestId}`;
  let t8;
  if ($[10] !== requestsLayout || $[11] !== t7) {
    t8 = <RequestBuilderPreview groupRequestId={t7} requestsLayout={requestsLayout} />;
    $[10] = requestsLayout;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      bgColor: "colorPalette.bg",
      borderRadius: 0,
      border: "none"
    };
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t6 || $[15] !== t8) {
    t10 = {
      id: "request-builder-preview",
      useDrawerBreakpoints: t5,
      resizeHandlePosition: "left",
      defaultWidth: t6,
      children: t8,
      containerProps: t9
    };
    $[14] = t6;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t4) {
    t11 = <AppLayout id="request-builder" scrollable={false} panelProps={t0} panels={[t4, t10]} />;
    $[17] = t10;
    $[18] = t4;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
};